import LogoSVG from '../../assets/logo/adamo-pay-logo.svg'

const LogoWhite = () => {
  return (
    <div className="login-logo-container">
      <img
        src={LogoSVG}
        alt="Logo"
        className="logo"
      />
    </div>
  )
}

export default LogoWhite
